import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'essential-violet',
  name: 'Essential violet',
  palette: {
    primary: '#00B5D9',
    accent: '#A64AE8',
    neutral: '#F7F4F9',
  },
  light1: {
    'action-primary': '#10bcde',
    'action-primary-hovered': '#52c6dd',
    'action-primary-pressed': '#1e98b0',
    'action-primary-subdued': '#f8f2fc',
    'action-primary-subdued-hovered': '#f2e9f7',
    'action-primary-subdued-pressed': '#f1e3fa',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f6f3f9',
    'action-neutral-pressed': '#f5e3ff',
    'action-neutral-subdued': '#eee6f2',
    'action-neutral-subdued-hovered': '#dbd1e3',
    'action-neutral-subdued-pressed': '#d3cad9',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#F8F6FA',
    'background-hovered': '#fffefe',
    'background-pressed': '#f4e8fc',
    'background-selected': '#ffffff',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#eef8ff',
    content: '#15181b',
    'content-subdued': '#25292e',
    'content-muted': '#5b6266',
    'content-hovered': '#58535b',
    'content-pressed': '#545454',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#8348bd',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#faf2ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1b1f21',
    'content-on-background-subdued': '#0f1c29',
    'content-on-background-hovered': '#252b2e',
    'content-on-background-pressed': '#722e93',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#ae5ced',
    'interactive-hovered': '#c97bf0',
    'interactive-pressed': '#af56db',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#ffffff',
    'topbar-subdued': '#fbf5ff',
    'content-on-topbar': '#2c3845',
    'line-on-topbar': '#e0c7f0',
    'line-on-topbar-pressed': '#f1dbff',
    link: '#9243b9',
    'link-hovered': '#a970c5',
    'link-pressed': '#7b359e',
    line: '#e7dfec',
    'line-subdued': '#f8f2fc',
    'line-hovered': '#cbc6cf',
    'line-pressed': '#b8b1ba',
    'line-selected': '#545454',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#000000',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#9243b9',
    skeleton: '#f1eaf4',
    surface: '#FFFFFF',
    'surface-subdued': '#f6f0fa',
    'surface-hovered': '#fef8ff',
    'surface-subdued-hovered': '#fdfaff',
    'surface-pressed': '#efe9f6',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f4eef9',
    'surface-selected-hovered': '#f7edff',
    'surface-selected-pressed': '#f1d9ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#f2edf5',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#59545c',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#10bcde',
    'action-primary-hovered': '#52c6dd',
    'action-primary-pressed': '#1e98b0',
    'action-primary-subdued': '#f8f2fc',
    'action-primary-subdued-hovered': '#f6ebfd',
    'action-primary-subdued-pressed': '#f6e8ff',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#fbf5ff',
    'action-neutral-pressed': '#f5e3ff',
    'action-neutral-subdued': '#eee6f2',
    'action-neutral-subdued-hovered': '#dbd1e3',
    'action-neutral-subdued-pressed': '#d3cad9',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#FFFFFF',
    'background-hovered': '#fffefe',
    'background-pressed': '#f4e8fc',
    'background-selected': '#ffffff',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#f3faff',
    content: '#15181b',
    'content-subdued': '#25292e',
    'content-muted': '#5b6266',
    'content-hovered': '#252a2e',
    'content-pressed': '#545454',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#8348bd',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#faf2ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1b1f21',
    'content-on-background-subdued': '#0f1c29',
    'content-on-background-hovered': '#252b2e',
    'content-on-background-pressed': '#722e93',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#ae5ced',
    'interactive-hovered': '#c97bf0',
    'interactive-pressed': '#af56db',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#FFFFFF',
    'topbar-subdued': '#ffffff',
    'content-on-topbar': '#2c3845',
    'line-on-topbar': '#e0c7f0',
    'line-on-topbar-pressed': '#f1dbff',
    link: '#9243b9',
    'link-hovered': '#a970c5',
    'link-pressed': '#7b359e',
    line: '#dfc7f0',
    'line-subdued': '#f8f2fc',
    'line-hovered': '#cbc6cf',
    'line-pressed': '#b8b1ba',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#000000',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#9243b9',
    skeleton: '#f9f6fa',
    surface: '#FFFFFF',
    'surface-subdued': '#f6f0fa',
    'surface-hovered': '#fef8ff',
    'surface-subdued-hovered': '#fdfaff',
    'surface-pressed': '#efe9f6',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f7f2fc',
    'surface-selected-hovered': '#f7edff',
    'surface-selected-pressed': '#f1d9ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#f2edf5',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#59545c',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#10bcde',
    'action-primary-hovered': '#52c6dd',
    'action-primary-pressed': '#1e98b0',
    'action-primary-subdued': '#fdfaff',
    'action-primary-subdued-hovered': '#f9f2ff',
    'action-primary-subdued-pressed': '#f6e8ff',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#ffffff',
    'action-neutral-hovered': '#fbf5ff',
    'action-neutral-pressed': '#f5e3ff',
    'action-neutral-subdued': '#eee6f2',
    'action-neutral-subdued-hovered': '#dbd1e3',
    'action-neutral-subdued-pressed': '#d3cad9',
    'action-neutral-disabled': '#f7f7f7',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#FFFFFF',
    'background-hovered': '#f7f1fd',
    'background-pressed': '#F8F6FA',
    'background-selected': '#ffffff',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#15181b',
    'content-subdued': '#323941',
    'content-muted': '#5b5e66',
    'content-hovered': '#58535b',
    'content-pressed': '#545454',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#8348bd',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#faf2ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1b1f21',
    'content-on-background-subdued': '#0f1c29',
    'content-on-background-hovered': '#252b2e',
    'content-on-background-pressed': '#722e93',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#ae5ced',
    'interactive-hovered': '#c97bf0',
    'interactive-pressed': '#af56db',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f3f7ff',
    topbar: '#fdfaff',
    'topbar-subdued': '#fbf5ff',
    'content-on-topbar': '#2c3845',
    'line-on-topbar': '#e0c7f0',
    'line-on-topbar-pressed': '#f1dbff',
    link: '#9243b9',
    'link-hovered': '#a970c5',
    'link-pressed': '#7b359e',
    line: '#e5ddeb',
    'line-subdued': '#f8f2fc',
    'line-hovered': '#cbc6cf',
    'line-pressed': '#b8b1ba',
    'line-selected': '#545454',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#10bcde',
    skeleton: '#ffffff',
    surface: '#F8F6FA',
    'surface-subdued': '#f6f0fa',
    'surface-hovered': '#fef8ff',
    'surface-subdued-hovered': '#fdfaff',
    'surface-pressed': '#eae4f1',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#ffffff',
    'surface-selected-hovered': '#f7edff',
    'surface-selected-pressed': '#f1d9ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#f2edf5',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#59545c',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#10bcde',
    'action-primary-hovered': '#52c6dd',
    'action-primary-pressed': '#1e98b0',
    'action-primary-subdued': '#3d3544',
    'action-primary-subdued-hovered': '#4e4457',
    'action-primary-subdued-pressed': '#2e2834',
    'action-primary-disabled': '#404040',
    'action-neutral': '#211e24',
    'action-neutral-hovered': '#2f2b34',
    'action-neutral-pressed': '#1c191f',
    'action-neutral-subdued': '#1c191f',
    'action-neutral-subdued-hovered': '#444951',
    'action-neutral-subdued-pressed': '#404040',
    'action-neutral-disabled': '#404040',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#404040',
    background: '#1c191f',
    'background-hovered': '#28232e',
    'background-pressed': '#debfff',
    'background-selected': '#292929',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#2e2b33',
    content: '#f7f1ff',
    'content-subdued': '#cec9d4',
    'content-muted': '#a1a1a1',
    'content-hovered': '#f2f2f2',
    'content-pressed': '#d4d4d4',
    'content-disabled': '#727272',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#f4e9ff',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f7f7f7',
    'content-on-interactive': '#f7f7f7',
    'content-on-background': '#f7f7f7',
    'content-on-background-subdued': '#d4d4d4',
    'content-on-background-hovered': '#f2f2f2',
    'content-on-background-pressed': '#1e1a21',
    'content-on-background-disabled': '#727272',
    interactive: '#ae5ced',
    'interactive-hovered': '#c97bf0',
    'interactive-pressed': '#af56db',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#17151a',
    'topbar-subdued': '#1e1a21',
    'content-on-topbar': '#f7f7f7',
    'line-on-topbar': '#404040',
    'line-on-topbar-pressed': '#737373',
    link: '#ba7aff',
    'link-hovered': '#ae62ff',
    'link-pressed': '#9c3fff',
    line: '#403e42',
    'line-subdued': '#2b2530',
    'line-hovered': '#545454',
    'line-pressed': '#737373',
    'line-selected': '#545454',
    'line-disabled': '#404040',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#debfff',
    skeleton: '#414043',
    surface: '#211e24',
    'surface-subdued': '#404040',
    'surface-hovered': '#252229',
    'surface-subdued-hovered': '#404040',
    'surface-pressed': '#545454',
    'surface-disabled': '#404040',
    'surface-selected': '#3d3445',
    'surface-selected-hovered': '#443d4f',
    'surface-selected-pressed': '#312b3b',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#1c191f',
    'surface-neutral-subdued': '#404040',
    'surface-inverse': '#f7f7f7',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#10bcde',
    'action-primary-hovered': '#52c6dd',
    'action-primary-pressed': '#1e98b0',
    'action-primary-subdued': '#3d3544',
    'action-primary-subdued-hovered': '#4e4457',
    'action-primary-subdued-pressed': '#2e2834',
    'action-primary-disabled': '#404040',
    'action-neutral': '#1c191f',
    'action-neutral-hovered': '#2f2b34',
    'action-neutral-pressed': '#1c191f',
    'action-neutral-subdued': '#1c191f',
    'action-neutral-subdued-hovered': '#404040',
    'action-neutral-subdued-pressed': '#404040',
    'action-neutral-disabled': '#282828',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#404040',
    background: '#211e24',
    'background-hovered': '#252229',
    'background-pressed': '#5d4e6c',
    'background-selected': '#36313b',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#2f2b33',
    content: '#f9f9f9',
    'content-subdued': '#e1dde4',
    'content-muted': '#a1a1a1',
    'content-hovered': '#f2f2f2',
    'content-pressed': '#d4d4d4',
    'content-disabled': '#727272',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#f5f3f7',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f7f7f7',
    'content-on-interactive': '#f7f7f7',
    'content-on-background': '#f7f7f7',
    'content-on-background-subdued': '#faf3ff',
    'content-on-background-hovered': '#f2f2f2',
    'content-on-background-pressed': '#f1f1f1',
    'content-on-background-disabled': '#727272',
    interactive: '#ae5ced',
    'interactive-hovered': '#c97bf0',
    'interactive-pressed': '#af56db',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#1e1a21',
    'topbar-subdued': '#17151a',
    'content-on-topbar': '#f7f7f7',
    'line-on-topbar': '#404040',
    'line-on-topbar-pressed': '#727272',
    link: '#ba7aff',
    'link-hovered': '#ae62ff',
    'link-pressed': '#9c3fff',
    line: '#403e42',
    'line-subdued': '#2b2530',
    'line-hovered': '#535353',
    'line-pressed': '#737373',
    'line-selected': '#545454',
    'line-disabled': '#404040',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#debfff',
    skeleton: '#414043',
    surface: '#1c191f',
    'surface-subdued': '#28242b',
    'surface-hovered': '#28242b',
    'surface-subdued-hovered': '#404040',
    'surface-pressed': '#404040',
    'surface-disabled': '#282828',
    'surface-selected': '#39333d',
    'surface-selected-hovered': '#3b3842',
    'surface-selected-pressed': '#312e36',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#211e24',
    'surface-neutral-subdued': '#404040',
    'surface-inverse': '#f7f7f7',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
